import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a3ee58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-center p-1 gap-5 container" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_6 = { class: "lista_atendimentos card p-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "header_list d-flex col-12 p-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-10 d-flex justify-content-start subtitulo" }, "NOME"),
  /*#__PURE__*/_createElementVNode("span", { class: "col d-flex justify-content-start subtitulo" }, "EDITAR")
], -1))
const _hoisted_8 = { class: "col-10 d-flex justify-content-start" }
const _hoisted_9 = {
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_10 = { class: "col d-flex justify-content-start" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Nenhum projeto encontrado ...", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center p-8 w-100 h-100"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto cor_texto_1" }, "Buscando Projetos...", -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Projetos")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          text: "Voltar",
          type: "button",
          onClick: _cache[0] || (_cache[0] = () => _ctx.router.back())
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          text: "Adicionar projeto",
          style: {"min-width":"fit-content"},
          onClick: _cache[1] || (_cache[1] = () => _ctx.router.push({ name: 'Project' }))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (_ctx.projectsArray.length > 0 && !_ctx.isLoading.status)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.projectsArray, (project, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              style: {"height":"fit-content","border-radius":"10px"},
              class: "usuario card d-flex flex-row col-12 p-5 align-items-center"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(project?.name || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  variant: "primary",
                  text: "Editar",
                  onClick: () => _ctx.router.push(`/project/edit/${project.id}`)
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        : (!_ctx.isLoading.status && _ctx.projectsArray.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
    ])
  ]))
}